export default "__VITE_ASSET__C4uzVa34__"